/*
 *   File : manage-template.js
 *   Author : https://evoqins.com
 *   Description : Manage template file
 *   Integrations :NA
 *   Version : 1.0.0
*/

import React, { Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal } from 'bootstrap';
import { EditorState, ContentState, convertFromHTML } from "draft-js";

//Style
import style from "../../Style/Component/mail.module.scss";

//Custom components
import { CustomEditor, CustomTextArea, CustomTextInput, FileSelector, EmailQuillEditor } from '../../Components/FormElements';
import { PrimaryButton, SecondaryButton } from '../../Components/Buttons';
import { SuccessModal } from '../../Components/Modal';
import { toast } from 'react-toastify';
import { APIService, AWSService } from '../../Service';
import { prepareQuillHtmlForEmail } from '../../Utils/quill-email';

const ManageTemplate = () => {

    const navigate = useNavigate();
    const { state } = useLocation();

    const [title, setTitle] = useState("");
    const [titleError, setTitleError] = useState("");

    const [content, setContent] = useState("");
    const [contentError, setContentError] = useState("");
    const [file, setFile] = useState(null);
    const [fileError, setFileError] = useState("");

    const [link, setLink] = useState("");
    const [linkError, setLinkError] = useState("");

    const [buttonName, setButtonName] = useState("");
    const [buttonNameError, setButtonNameError] = useState("");

    const [successModal, setSuccessModal] = useState(false);

    const [emailContent, setEmailContent] = useState("");
    const [emailContentError, setEmailContentError] = useState("");

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        if (state !== null) {
            if (state.edit_data) {
                setTitle(state.edit_data.title);
                // setContent(state.edit_data.content);
                console.log('state.edit_data', state.edit_data);

                // setEmailContent(state.edit_data.content);

                if (state.edit_data?.content) {
                    setEmailContent(state.edit_data.content);
                }


                setFile(state.edit_data?.image ?? null);
                setButtonName(state.edit_data?.button_name ?? "")
                setLink(state.edit_data?.redirection_link ?? "");
            }
        }
    }, [state]);

    useEffect(() => {
        if (successModal === true) {
            const modal = new Modal(document.getElementById("success-modal"));
            modal.show();
        }
    }, [successModal]);

    useEffect(() => {
        setTitleError("");
    }, [title]);

    useEffect(() => {
        setContentError("");
    }, [content]);

    useEffect(() => {
        setFileError("");
    }, [file]);

    useEffect(() => {
        setLinkError("");
    }, [link]);

    useEffect(() => {
        setButtonNameError("");
    }, [buttonName, link]);

    useEffect(() => {
        setEmailContentError("");
    }, [emailContent]);

    // handle back 
    const _handleBack = () => {
        navigate("/send-mail");
    };

    const _handleChangeEmailContent = (value) => {
        setEmailContent(value);
    };


    // handle change
    const _handleChange = (file) => {
        // const preview = URL.createObjectURL(file);
        // setFile(preview);
        // // _getPresignedUrl(file);

        if (file.size > 1024 * 1024 * 10) {
            setFileError("File size exceeds the maximum limit of 10 MB");
            return;
        }
        _getPresignedUrl(file);
    };

    // handle clear file
    const _handleClear = () => {
        setFile(null);
    };

    // handle add template 
    const _handleAddTemplate = () => {
        let is_valid = true;

        if (title.trim().length === 0) {
            setTitleError("Please provide template title");
            is_valid = false;
        }
        // if (content.trim().length === 0) {
        //     setContentError("Please provide template content");
        //     is_valid = false;
        // }

        if (emailContent.length === 0) {
            setEmailContentError("Please provide content");
            is_valid = false;
        }

        // if (file === null) {
        //     setFileError("Please provide banner image");
        //     is_valid = false;
        // }

        // if (link.trim().length === 0) {
        //     setLinkError("Please provide redirection link");
        //     is_valid = false;
        // }

        if (link.trim().length !== 0 & buttonName.trim().length === 0) {
            setButtonNameError("Please provide redirection button name");
            is_valid = false;
        }

        if (is_valid === true) {

            _manageTemplate();

        }
    };

    const [fileLoader, setFileLoader] = useState(false);

    // Get - presigned url
    async function _getPresignedUrl(file) {

        let is_post = true;
        let url = 'file/upload';
        let data = {
            "type": "ADMIN",
            "file": file.name,
            "is_public": true
        };

        setFileLoader(true);
        // setFileName(data)

        try {
            let response = await APIService(is_post, url, data);
            if (response.status_code == 200) {
                let aws_fields = response.data.upload_info.fields;
                let aws_url = response.data.upload_info.url;

                try {
                    let aws_response = await AWSService(aws_fields, file, aws_url);
                    if (aws_response.status == 'ok') {
                        setFile(response.data.view_info);
                    } else {
                        toast.dismiss();
                        toast.error(aws_response.message, {
                            type: "error",
                            className: "e-toast",
                        });
                    }
                } catch (err) {
                    console.log("error")
                }
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
        } catch (err) { }
        setFileLoader(false);
    };

    const [loader, setLoader] = useState(false);

    console.log('emailContent', emailContent);

    // API - Add or update template
    const _manageTemplate = () => {

        let is_post = true;
        let url = 'send-email/add-template';
        let request = {
            "template_id": state?.edit === true ? state.edit_data.template_id : null,
            "title": title,
            "content": prepareQuillHtmlForEmail(emailContent),
            "image": file ?? null,
            "redirection_url": link.length !== 0 ? link : null,
            "button_name": buttonName.length !== 0 ? buttonName : null
        }

        setLoader(true);
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setSuccessModal(true);
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setLoader(false);
        });
    };

    return (
        <Fragment>
            <section className='e-section-height pb-5' >
                <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom'>
                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-400 line-height-24px'>
                        <span className='text-decoration-hover-underline cursor-pointer'
                            onClick={() => _handleBack()}>Send Mail</span> / <span className='e-font-weight-600'>
                            {state?.edit === true ? "Edit template" : "Add template"}
                        </span>
                    </p>
                </div>

                <div className='padding-52px-lr margin--80px-top'>
                    <div className={`${style.e_wrapper} e-bg-white border-radius-16 padding-32px-all`}>
                        <h4 className='mb-4 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                            {state?.edit === true ? "Edit template" : "Add template"}
                        </h4>
                        <div className='row'>
                            <div className='col-9'>
                                <div className='d-flex flex-column gap-4 mb-4'>
                                    {/* Template title */}
                                    <CustomTextInput label="Template title"
                                        placeholder="Enter template title"
                                        type="text"
                                        autoFocus={true}
                                        required={true}
                                        value={title}
                                        error={titleError}
                                        className="w-100 "
                                        inputType={2}
                                        handleChange={(e) => setTitle(e)} />
                                    {/* Template content* */}
                                    {/* <CustomTextArea label="Template content"
                                        placeholder="Enter content"
                                        type="text"
                                        onFocus={true}
                                        value={content}
                                        error={contentError}
                                        required={true}
                                        className="w-100"
                                        borderStyle="e-border-0-5px-arsenic"
                                        handleChange={(e) => setContent(e)} /> */}

                                    {/* <CustomTextInput label="Email subject"
                                        placeholder="Enter subject"
                                        type="text"
                                        required={true}
                                        value={emailSubject}
                                        error={emailSubjectError}
                                        className="w-100 "
                                        inputType={2}
                                        handleChange={(e) => setEmailSubject(e)} /> */}

                                    <div className='mt-'>
                                        {/* <CustomEditor label="Email content"
                                            required={true}
                                            editorState={emailContent}
                                            error={emailContentError}
                                            onEditorStateChange={_handleChangeEmailContent} /> */}

                                        <EmailQuillEditor label="Email content"
                                            value={emailContent}
                                            required={true}
                                            error={emailContentError}
                                            onEditorStateChange={setEmailContent} />
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-6'>
                                        <FileSelector
                                            title='Upload template image'
                                            required={false}
                                            type={1}
                                            loader={fileLoader}
                                            fileType={["PNG"]}
                                            error={fileError}
                                            height="h-280px"
                                            value={file}
                                            primeDataClass="flex-column align-items-start"
                                            handleChange={_handleChange}
                                            handleClose={_handleClear} />
                                    </div>
                                </div>

                                <div className='pb-4'>
                                    <CustomTextInput label="Redirection button name"
                                        placeholder="Enter button name"
                                        type="text"
                                        required={link.length !== 0}
                                        value={buttonName}
                                        error={buttonNameError}
                                        className="w-100"
                                        inputType={2}
                                        handleChange={(e) => setButtonName(e)} />
                                </div>

                                {/* Redirection Link */}
                                <CustomTextInput label="Redirection Link"
                                    placeholder="Rayi App"
                                    type="text"
                                    required={false}
                                    value={link}
                                    error={linkError}
                                    className="w-100"
                                    inputType={2}
                                    handleChange={(e) => setLink(e)} />



                                <div className='d-flex align-items-center gap-4 pt-4 mt-2 justify-content-end'>
                                    <SecondaryButton name='Cancel'
                                        className="e-text-smoky-black"
                                        paddingBlock='padding-12px-tb padding-52px-lr'
                                        onClick={_handleBack} />
                                    <PrimaryButton name={state?.edit === true ? "Update template" : "Add template"}
                                        paddingBlock='padding-12px-tb padding-32px-lr'
                                        loader={loader}
                                        className={loader ? "w-146px" : ""}
                                        onClick={_handleAddTemplate} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {successModal === true &&
                <SuccessModal title="Success!"
                    description={`The template has been ${state?.edit === true ? "updated" : "added"} successfully.`}
                    handleSuccess={_handleBack} />
            }
        </Fragment>
    )
}

export default ManageTemplate;
